
  var _styles = {
  "skeleton-container-view": {
    "width": "100%",
    "paddingTop": "0.21333rem",
    "paddingRight": "0.21333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.21333rem",
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "backgroundColor": "rgba(0,0,0,0)"
  },
  "skeleton-container-item": {
    "width": "33.3%",
    "height": "4.74667rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "marginBottom": "0.26667rem"
  },
  "skeleton-container": {
    "width": "3.01333rem",
    "height": "4.74667rem",
    "borderRadius": "0.24rem",
    "position": "relative",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "rgb(255,255,255)"
  },
  "skeleton-column": {
    "position": "absolute",
    "backgroundColor": "rgb(247,247,247)",
    "borderRadius": "0.05333rem",
    "overflow": "hidden"
  }
};



  module.exports = _styles;
  